import { render, staticRenderFns } from "./HeadlineImageField.vue?vue&type=template&id=27d9ae59&scoped=true"
import script from "./HeadlineImageField.vue?vue&type=script&lang=ts"
export * from "./HeadlineImageField.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineImageField.vue?vue&type=style&index=0&id=27d9ae59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9ae59",
  null
  
)

export default component.exports